/**
 * 환경에 따른 경로 접두사 관리 유틸리티
 */ /**
 * VSCode 환경인지 확인하는 함수
 */ export var isVSCodeEnvironment = function() {
    // VSCode Webview 환경을 감지하는 여러 방법 적용
    if (typeof window !== 'undefined') {
        // 1. window.acquireVsCodeApi 존재 여부 확인 - 가장 신뢰할 수 있는 방법
        var hasVsCodeApi = typeof window.acquireVsCodeApi === 'function';
        // 2. URL에 vscode 관련 패턴이 있는지 확인
        var urlContainsVSCode = window.location.href.includes('vscode-webview') || window.location.href.includes('vscode-file');
        // 3. 정의된 전역 VSCode 변수 확인
        var hasVSCodeGlobal = 'vscodeApi' in window;
        // iframe 확인은 제거 - 일반 웹에서도 iframe을 사용할 수 있음
        // VSCode 환경은 위의 세 가지 조건 중 하나를 만족해야 함
        return hasVsCodeApi || urlContainsVSCode || hasVSCodeGlobal;
    }
    return false;
};
/**
 * 현재 환경에 맞는 경로 접두사를 반환하는 함수
 */ export var getPathPrefix = function() {
    // VS Code webview에서는 prefix가 필요 없음
    return '';
};
/**
 * 환경에 맞게 라우팅 경로를 생성하는 함수
 * @param path 기본 경로 (접두사 제외)
 * @returns 환경에 맞게 접두사가 추가된 전체 경로
 */ export var getRoutePath = function(path) {
    // VS Code webview에서는 prefix 없이 그대로 반환
    var pathWithSlash = path.startsWith('/') ? path : "/".concat(path);
    return pathWithSlash;
};
